

import { mapGetters } from 'vuex'
import specialProductListingItem from '../../common/mixins/products/specialProductListingItem'
import hnhImg from '../../common/assets/half-half.png'

export default {
  name: 'HalfNHalf',
  mixins: [specialProductListingItem],
  computed: {
    ...mapGetters(['currentStore'])
  },
  data () {
    return {
      hnhImg
    }
  }
}
